import React, {useState} from 'react';
import {connect} from 'react-redux';
import HorzintalBarScoreRow from '../../options/optionsGraphs/HorzintalBarScoreRow'

function OptionScore(props){
  return (
    <span>
        {"In each option you can see the final score given to that option.\
        Furthermore you can see how the score is built from the scores in the diffrent aspects."}
        <table style={{width:"100%"}}>
         <tr>
           <td  className={"option-score" }  style={{fontSize:"30px"}}>{props.optionData.score}</td>
           <td><HorzintalBarScoreRow option={props.optionData} scores={props.scores[props.optionData.id]} nodes={props.nodes}/></td>
         </tr>
         <tr>
           <td>{"Total Score"}</td>
           <td>{"The distribution of the score between the diffrent aspects."}</td>
         </tr>
        </table>
      </span>);
}

const mapStateToProps = (state) => ({
  optionData: state.options.optionsChosen[0],
  scores: state.options.extendedScores,
  nodes: state.preferenceTree.root_node?state.preferenceTree.root_node.children:[],
})

const actionsCreators = {

}

const _ = connect(mapStateToProps, actionsCreators)(OptionScore)
export default OptionScore = () => <_/>
